export const toggleSwitchAction = (actions, values, active) => {
  const actionValue = JSON.parse(JSON.stringify(actions));
  actionValue.forEach((item, index) => {
    switch (item.actionType) {
      case 'callServices':
        if (values.addonCoverageCodes) {
          item.props.services[0].serviceParams.forEach((fieldItem, fieldIndex) => {
            if (active) {
              actionValue[index].props.services[0].serviceParams[fieldIndex].value =
              values.addonCoverageCodes
                .filter(x => !fieldItem.value.includes(x))
                .concat(fieldItem.value.filter(x => !values.addonCoverageCodes.includes(x)));
            } else {
              actionValue[index].props.services[0].serviceParams[fieldIndex].value =
              [...new Set([...values.addonCoverageCodes, ...fieldItem.value])];
            }
          });
        }
        break;
      case 'changeUserData':
        if (values.addonCoverageCodes) {
          item.props.fields.forEach((fieldItem, fieldIndex) => {
            if (active) {
              actionValue[index].props.fields[fieldIndex].value =
              values.addonCoverageCodes
                .filter(x => !fieldItem.value.includes(x))
                .concat(fieldItem.value.filter(x => !values.addonCoverageCodes.includes(x)));
            } else {
              actionValue[index].props.fields[fieldIndex].value =
              [...new Set([...values.addonCoverageCodes, ...fieldItem.value])];
            }
          });
        }
        break;
      default:
        break;
    }
  });
  return actionValue;
};